<template>
    <v-form @submit.prevent ref="form">
        <v-container grid-list-md>
            <v-layout row wrap justify-center>
                <v-flex grow v-if="addressFields.street !== undefined">
                    <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Straße*' | translation }}</p>
                    <v-text-field
                        :disabled="isDisabled"
                        v-model="localAddressFields.street"
                        :rules="[rules.required]"
                        :label="inputLabelOutside ? '' : $language.translate('Straße*')"
                        required
                        :solo="inputSolo"
                        :input-label-outside="inputLabelOutside"
                    >
                    </v-text-field>
                </v-flex>

                <v-flex v-if="addressFields.houseNumber !== undefined" xs3>
                    <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'House number' | translation }}</p>
                    <v-text-field
                        :disabled="isDisabled"
                        v-model="localAddressFields.houseNumber"
                        :rules="[rules.required]"
                        :label="inputLabelOutside ? '' : $language.translate('House number*')"
                        :solo="inputSolo"
                        :input-label-outside="inputLabelOutside"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <v-layout row justify-center :wrap="$vuetify.breakpoint.xs">
                <v-flex
                    v-if="addressFields.postCode !== undefined"
                    :xs4="$vuetify.breakpoint.xs"
                >
                    <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Postleitzahl*' | translation }}</p>
                    <v-text-field
                        :disabled="isDisabled"
                        v-model="localAddressFields.postCode"
                        :rules="[rules.required, rules.postCode]"
                        :label="inputLabelOutside ? '' : $language.translate('Postleitzahl*')"
                        required
                        :solo="inputSolo"
                        :input-label-outside="inputLabelOutside"
                    >
                    </v-text-field>
                </v-flex>

                <v-flex v-if="addressFields.city !== undefined">
                    <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Stadt*' | translation }}</p>
                    <v-text-field
                        :disabled="isDisabled"
                        v-model="localAddressFields.city"
                        :rules="[rules.required]"
                        :label="inputLabelOutside ? '' : $language.translate('Stadt*')"
                        required
                        :solo="inputSolo"
                        :input-label-outside="inputLabelOutside"
                    >
                    </v-text-field>
                </v-flex>

                <v-flex
                    v-if="addressFields.country !== undefined"
                    sm5
                    xs12
                >
                    <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Land*' | translation }}</p>
                    <v-select
                        :disabled="isDisabled"
                        v-model="localAddressFields.country"
                        :items="countryItems"
                        :rules="[rules.required]"
                        :label="inputLabelOutside ? '' : $language.translate('Land*')"
                        required
                        :solo="inputSolo"
                        :input-label-outside="inputLabelOutside"
                    >
                        <template v-slot:item="data">
                            {{ data.item.text | translation }}
                        </template>
                        <template v-slot:selection="data">
                            {{ data.item.text | translation }}
                        </template>
                    </v-select>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import ShippingSelector from '@breakmedia/prime-vue-basket/src/ShippingSelector';
    import postalCodes from "postal-codes-js";

    export default {
        name: 'AddressForm',
        props: {
            inputLabelOutside: Boolean,
            isDisabled: Boolean,
            inputSolo: Boolean,
            addressFields: {
                street: undefined,
                houseNumber: undefined,
                postCode: undefined,
                city: undefined,
                country: undefined,
            },
        },
        data() {
            return {
                rules: {
                    required: value => !!value || 'Dieses Feld wird benötigt und darf nicht leer sein.',
                    postCode: value => {
                        let result = true;

                        if (this.country) {
                            result = postalCodes.validate(this.country.toLowerCase(), value);

                            if(result !== true) {
                                return this.$language.translate('Postal code is not valid.');
                            }
                        }

                        return result;
                    },
                },
                localAddressFields: Object.assign({}, this.addressFields),
            };
        },
        created() {
            if (!Object.keys(this.shippingCountries).length) {
                this.loadPossibleShippingCountries();
            }
        },
        computed: {
            ...mapState(ShippingSelector.name, [
                'shippingCountries',
            ]),
            countryItems() {
                let countries = Object.values(this.shippingCountries);
                let result = [];
                countries.forEach(country => result.push({
                    text: country.countryName,
                    value: country.iso_2,
                }));

                return result;
            },
        },
        methods: {
            ...mapActions(ShippingSelector.name, [
                'loadPossibleShippingCountries',
            ]),
            validate() {
                return this.$refs.form.validate();
            },
        },
        watch: {
            localAddressFields: {
                deep: true,
                handler(val) {
                    this.$emit('update:addressFields', val);
                },
            },
        },
    };
</script>